import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { IMessagetype } from 'src/app/models/IMessagetype';
import { IMessaging, IMessagingReceived, IMessagingSender, IMessagingCC, IMsgattachment } from 'src/app/models/IMessaging';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { ToastrService } from 'ngx-toastr';

export interface Priority {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-new-message',
  templateUrl: './new-message.component.html',
  styleUrls: ['./new-message.component.css']
})
export class NewMessageComponent implements OnInit {

  Priorities: Priority[] = [
    { value: 'High', viewValue: 'High' },
    { value: 'Medium', viewValue: 'Medium' },
    { value: 'Low', viewValue: 'Low' }
  ];

  newmessageform: FormGroup;
  submitted = false;
  public roles: IUserDetails[];
  public filterroles: IUserDetails[];
  public messageTypes: IMessagetype[];


  constructor(private formBuilder: FormBuilder, private activeserviceService: ActiveserviceService, private toastr: ToastrService, private messageService: MessagesService) { }
  createBy: string = "";
  ngOnInit() {
    if (CommonComponents.physicianName == null || CommonComponents.physicianName == undefined) {
      CommonComponents.physicianName = sessionStorage.getItem("physicianName");
    }
    this.createBy = sessionStorage.getItem("userId");
    this.newmessageform = this.formBuilder.group({
      msgtype: ['',],
      priority: ['',],
      pname: ['',],
      to: ['',],
      cc: ['',],
      subject: ['',],
      message: ['',],
    });
    this.msgsender = new IMessagingSender;
    this.getAllRoles();
    this.getAllMessageTypes();
  }

  getAllRoles() {
    this.messageService.getAllUsers().subscribe(data => {
      this.roles = data;
    },
      (err: any) => console.log(err)
    );
  }
  getAllMessageTypes() {
    this.messageService.getAllMessageTypes().subscribe(data => {
      this.messageTypes = data;
    },
      (err: any) => console.log(err)
    );
  }
  onSelectionChanges(value, type) {
    if (type == 'MessageType') {
      this.newmessageform.patchValue({
        msgtype: value
      });
    }

    if (type == 'priority') {
      this.newmessageform.patchValue({
        priority: value
      });
    }
  }
  onMessageChange(event) {
    this.newmessageform.patchValue({
      message: event.target.value
    });
  }
  OnSubjectChange(event, type) {
    if (type == 'subject') {
      this.newmessageform.patchValue({
        subject: event.target.value
      });
    }
    if (type == 'Patient') {
      this.newmessageform.patchValue({
        pname: event.target.value
      });
    }
  }
  toArray: string[] = [];
  ccArray: string[] = [];
  onSelectionChangeToCC(event, type, user) {
    if (type == 'to') {
      this.toArray = event.value;
    }
    if (type == 'cc') {
      this.ccArray = event.value;
    }
  }
  messaging: IMessaging = new IMessaging;
  msgsender: IMessagingSender;
  msgreceived: IMessagingReceived[] = [];
  msgcc: IMessagingCC[] = [];
  msgAttachments: IMsgattachment[] = [];
  msgreceiver: IMessagingReceived;
  msgccs: IMessagingCC;
  msgAttachment: IMsgattachment;
  filteruser: any[] = [];

  MapValuesforSender() {
    this.filteruser = this.roles.filter(a => a.userId == this.createBy);
    this.msgsender.senderId = 0;
    this.msgsender.senderUserID = this.createBy;
    this.msgsender.roleID = this.filteruser[0].roleId;
    this.msgsender.messageType = Number(this.newmessageform.value.msgtype);
    this.msgsender.priority = this.newmessageform.value.priority;
    this.msgsender.subject = this.newmessageform.value.subject;
    this.msgsender.body = this.newmessageform.value.message;
    this.msgsender.isDeleted = false;
    this.msgsender.isVisible = false;
    this.msgsender.dbOpertion = "Insert";
    this.msgsender.createdBy = this.createBy;
    this.msgsender.createdOn = new Date;
    this.msgsender.messageName = "";
    this.msgsender.imageSource = "";
    this.msgsender.receiverUserID = this.toArray.toString();
    this.msgsender.senderFullName = this.filteruser[0].userName;
    this.msgsender.receiverFullName = "";
    this.msgsender.amendmentId = 0;
    this.msgsender.amendmentStatus = "";
    this.msgsender.attachmentName = "";
    this.msgsender.attachment = "";
    this.msgsender.listUsersTo = this.toArray.toString();;
    this.msgsender.listUsersCC = this.ccArray.toString();;
    this.msgsender.toOrCC = "";
    this.msgsender.patName = this.newmessageform.value.pname;
    this.filteruser.length = 0;
  }

  MapValuesforReceiver(user) {
    this.msgreceiver = new IMessagingReceived;
    this.msgreceiver.patName = this.newmessageform.value.pname;
    this.msgreceiver.receiverID = 0;
    this.msgreceiver.senderID = 0;
    this.msgreceiver.listUsersTo = this.toArray.toString();
    this.msgreceiver.listUsersCC = this.ccArray.toString();
    this.msgreceiver.toOrCC = "";
    this.msgreceiver.roleID = user.roleId;
    this.msgreceiver.receiverUserID = user.userId;
    this.msgreceiver.dbOpertion = "Insert";
    this.msgreceiver.isActive = false;
    this.msgreceiver.isVisible = false;
    this.msgreceiver.isDeleted = false;
    this.msgreceiver.createdBy = this.createBy;
    this.msgreceiver.createdOn = new Date;
    this.msgreceiver.receiverFullName = user.userName;
    this.msgreceiver.attachmentName = "";
    this.msgreceiver.attachment = "";
    this.msgreceived.push(this.msgreceiver);
    this.msgreceiver = null;
  }

  MapValuesforCC(user: IUserDetails) {
    this.msgccs = new IMessagingCC;
    this.msgccs.ccid = 0;
    this.msgccs.senderID = 0;
    this.msgccs.ccUserID = user.userId;
    this.msgccs.dbOpertion = "Insert";
    this.msgccs.isActive = false;
    this.msgccs.isVisible = false;
    this.msgccs.isDeleted = false;
    this.msgccs.createdBy = this.createBy;
    this.msgccs.createdOn = new Date;
    this.msgcc.push(this.msgccs);
    this.msgccs = null;
  }

  MapValuesforAttachment() {
    this.msgAttachment.attId = 0;
    this.msgAttachment.senderID = 0;
    this.msgAttachment.senderUserID = "";
    this.msgAttachment.recieverUserID = "";
    this.msgAttachment.attachmentName = "";
    this.msgAttachment.attachments = "";
    this.msgAttachment.mId = 0;
    this.msgAttachment.attachFilePath = "";
    this.msgAttachment.extension = "";
    this.msgAttachment.attachmentDescription = "";
    this.msgAttachment.isActive = false;
    this.msgAttachment.dbOpertion = "";
    this.msgAttachments.push(this.msgAttachment);
  }
  onSendClick() {
    this.MapValuesforSender();
    if (this.toArray.length > 0) {
      for (let index = 0; index < this.toArray.length; index++) {
        this.filterroles = this.roles.filter(a => a.userId == this.toArray[index])
        this.MapValuesforReceiver(this.filterroles[0]);
        this.filterroles.length = 0;
      }
    }
    if (this.ccArray.length > 0) {
      for (let index = 0; index < this.ccArray.length; index++) {
        this.filterroles = this.roles.filter(a => a.userId == this.ccArray[index])
        this.MapValuesforCC(this.filterroles[0]);
        this.filterroles.length = 0;
      }
    }
    this.messaging.messagingSenders = this.msgsender;
    this.messaging.lstmessagingReceiveds = this.msgreceived;
    this.messaging.lstMessagingCC = this.msgcc;
    this.messaging.lstAttachments = this.msgAttachments;
    this.InsertMessage(this.messaging);
  }
  result: string = "";

  InsertMessage(message: IMessaging) {
    this.messageService.insertSenderMessageDetails(message, this.createBy).subscribe(data => {
      this.result = data;
      this.toastr.success(this.result);
    },
      (err: any) => {
        console.log(err)
        this.result = err;
        this.toastr.error(this.result);
      }
    );
    this.clearSelection();
  }

  onCancel() {
    this.clearSelection();
  }

  clearSelection() {
    this.newmessageform.patchValue({
      msgtype: '',
      priority: '',
      pname: '',
      to: '',
      cc: '',
      subject: '',
      message: '',
    });
  }

}
